module.exports = __webpack_public_path__ + "img/Summary.66df0620.svg";